import React from "react";
import { Mail, Phone, MapPin, Instagram } from "lucide-react";

const AboutUs = () => {
  return (
    <div className="policy-container">
      <h1>About Us</h1>
      <p>
        <strong>Forever Speed Skating Academy</strong> is a premier destination for skating enthusiasts in Mumbai. Whether you're a beginner or an aspiring athlete, our mission is to inspire confidence, build skills, and promote the joy of skating.
      </p>

      <h2>Our Journey</h2>
      <p>
        What started as a humble initiative has grown into one of the most trusted names in skating education. With a strong foundation built on discipline, safety, and fun, we’ve empowered hundreds of students to embrace the thrill of speed skating across Mumbai.
      </p>

      <h2>Why Choose Forever Speed Skating Academy?</h2>
      <ul>
        <li><strong>Expert Coaching:</strong> Our trained instructors help students overcome fear and master balance, technique, and speed.</li>
        <li><strong>Proven Track Record:</strong> Rated 4.7 stars, we are among the top-rated skating classes in the city.</li>
        <li><strong>Prime Locations:</strong> Airoli, Goregaon West, and Naigaon West.</li>
        <li><strong>Supportive Environment:</strong> We prioritize safety, encouragement, and individual growth for all ages.</li>
        <li><strong>Growing Community:</strong> From local skaters to competitive talents, our student base is rapidly expanding.</li>
      </ul>

      <h2>What We Offer</h2>
      <ul>
        <li>Skating training programs for beginner, intermediate, and advanced levels.</li>
        <li>Personalized coaching and group sessions.</li>
        <li>Inter-school and state-level skating competition opportunities.</li>
        <li>Focus on safety gear, skating ethics, and proper technique.</li>
      </ul>

      <h2>Our Vision</h2>
      <p>
        To make skating accessible and enjoyable for everyone—children, youth, and adults—while instilling discipline, fitness, and fun.
      </p>

      <h2>Visit Us</h2>
      <ul>
        <li><MapPin size={16} /> Airoli Sector 8A, Near Dmart, Opp. Sai Sneha Restaurant</li>
        <li><MapPin size={16} /> Aquanus International School, MG Road, Goregaon West</li>
        <li><MapPin size={16} /> CJM School, Opp. Pali Church, Naigaon West</li>
      </ul>

      <h2>Get in Touch</h2>
      <p><Phone size={16} /> +91 79775 63085</p>
      <p><Mail size={16} /> fssacademy2020@gmail.com</p>
      <p>
        <Instagram size={16} />{" "}
        <a href="https://www.instagram.com/foreverspeedskating?igsh=MXd4MWd4aHhlajFvNA==" target="_blank" rel="noopener noreferrer">
          Instagram Page
        </a>
      </p>
    </div>
  );
};

export default AboutUs;
